export default __webpack_public_path__ + "static/media/whiskeybackground1.dd959557.jpg";